import React, { useState, useEffect } from "react";
import Header from "../../../../Components/Header";
import SingleSignOnSideBar from "../../../../Components/SingleSignOnSideBar";
import womenImg from "../../../../asset/images/ibaimages/womenImg.svg";
import "./ibaPayoutApproval.scss";
import { Button, Modal } from "react-bootstrap";
import warningiba from "../../../../asset/images/ibaimages/warning-iba.svg";
import IbaHoldPayout from "../IbaHoldPayout/IbaHoldPayout";
import LoaderForSearch from "../../../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import ibadown from '../../../../asset/images/ibaimages/iba-down.svg';
import { useAgents } from "../../hooks/useAgents";
import { IBA_Admin_Section } from "../../../../Configuration/API_URL";
import SmallLoader from "../../../../Components/Common/smallLoader";
import Loader from "../../../../Components/Common/Loader";
import { getInitials } from "../../../../CommonMethhods/CommonMethods";
import axios from "axios";

const IbaPayoutApproval = () => {
  const userId = localStorage.getItem("userId")
  const [showModal, setShowModal] = useState(false);
  const [showHoldPayout, setShowHoldpayout] = useState(false);
  const [csvLoader, setCsvLoader] = useState(false);
  const [sortedAgents, setSortedAgents] = useState([]);

  const { agents, loading, scrollLoading, handleScroll, fetchAgents } =
    useAgents();

    useEffect(() => {
  setSortedAgents(agents);
}, [agents]);

  // Download CSV
  const handleDownload = async () => {
    setCsvLoader(true);
          const payload={
          searchKey :"",
      }
    try {
      const response = await axios.post(
       IBA_Admin_Section.agentPayoutListDownload,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            reserv: 0,
          },
        }
      );
      const resVal = response?.data;
      if (resVal?.status === 0) {
        window.open(resVal?.data, "_self", "noopener,noreferrer");
      } else {
        toast.error(resVal?.message);
      }
    } catch (error) {
      console.error("Error downloading CSV:", error);
    }
    finally{
    setCsvLoader(false);
    }
  };
  
  const buildApprovePayload = (status, agentList = agents) => {
  const currentMonth = new Date()
    .toLocaleString("en-US", { month: "short" })
    .toUpperCase();

  return {
    month: currentMonth,
    approvedBy: userId,
    data: agentList.map((agent) => ({
      agentId: agent?.TelecallerId,
      iBAName: agent?.IBAName,
      accountsOpened: String(agent?.AccountsOpened ?? "0"),
      totalTalktime: String(agent?.TotalTalktime ?? "0"),
      totalPayout: String(agent?.TotalPayout ?? "0.00"),
      payoutStatus: status,
    })),
  };
};

const ascendingOrder = (column) => {
    const sortedList = [...sortedAgents].sort((a, b) => {
      if (typeof a[column] === 'string') {
        return a[column].localeCompare(b[column] || "");
      } else {
        return a[column] - b[column];
      }
    });
    setSortedAgents(sortedList);
  };

  const descendingOrder = (column) => {
    const sortedList = [...sortedAgents].sort((a, b) => {
      if (typeof a[column] === 'string') {
        return b[column].localeCompare(a[column] || "");
      } else {
        return b[column] - a[column];
      }
    });
    setSortedAgents(sortedList);
  };

  const approvePayout = async (status, agentList) => {
    const selectedAgents = agentList?.length ? agentList : agents;
       if (!agents || agents.length === 0) {
    toast.error("No agents available for approval");
    return;
  }

  const payload = buildApprovePayload(status, selectedAgents);
      try {
        const response = await axios.post(
          IBA_Admin_Section.approvePayoutData,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              reserv: 0,
              Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
            },
          }
        );
        const data = await response.data;
        if (data.status === 0) {
          setShowModal(false);
          toast.success(data?.data)
          fetchAgents();
            
        } else {
          toast.error(data?.message)
        }
      } catch (err) {
        console.log(err);
      }
    };
  
    const handleApprove=(status, agentList)=>{
      approvePayout(status, agentList)
    }

  return (
    <div>
      <Header portal={"IBA"} />
      <SingleSignOnSideBar />

      {!showHoldPayout ? (
        <main id="main-content" className="telecallerDash iba-page">
          <div className="agent-table-wrapper mb-3">
            <div className="header">
              <h2>Agent Payout</h2>
              <button
                className="hold-payout-btn"
                onClick={() => setShowHoldpayout(true)}
              >
                Hold Payout
              </button>
            </div>

              <table className="agent-table agent-payout-new">
                  <thead>
                    <tr className="agentTable-tr">
                      <th>Agent Name</th>
                      <th>Talktime (in minutes)</th>
                      <th className="accord-th">
                        <span>Accounts Opened</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                            onClick={() => descendingOrder("AccountsOpened")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => ascendingOrder("AccountsOpened")}
                          ></span>
                        </span>
                      </th>

                      <th className="accord-th">
                        <span>Total Payout</span>
                        <span className='wrap-icons'>
                          <span
                            className="icon-up-triangle"
                            onClick={() => descendingOrder("TotalPayout")}
                          ></span>
                          <span
                            className="icon-down-triangle"
                            onClick={() => ascendingOrder("TotalPayout")}
                          ></span>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  
                  <tbody onScroll={handleScroll}>
                    {loading ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          <div className="d-flex  justify-content-center">
                            <LoaderForSearch />
                          </div>
                        </td>
                      </tr>
                    ) : sortedAgents?.length > 0 ? (
                      <>
                        {sortedAgents?.filter(agent => agent?.PayoutStatus !== "APPROVED" || "HOLD")
                        .map((agent) => (
                          
                          <tr key={agent?.TelecallerId}>
                            
                            <td className="name-cell">
                              <div className='show-initial avatar-text'>
                              <span className='init-text'>{getInitials(agent?.IBAName || "N/A")}</span>
                            </div>
                              {/* <img src={womenImg} alt="avatar" className="avatar" /> */}
                              {agent?.IBAName}
                            </td>
                            <td>{agent?.TotalTalktime}</td>
                            <td>{agent?.AccountsOpened}</td>
                            <td>{agent?.TotalPayout}</td>
                            {/* <td className="details-cell">
                              <button className="performance-btn">Structure</button>
                            </td> */}
                          </tr>
                        ))}
                        {scrollLoading && (
                          <div className="d-flex justify-content-center">
                            <LoaderForSearch />
                          </div>
                        )}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No agents found
                        </td>
                      </tr>
                    )}
                  </tbody>
                  
            </table>
          </div>

          {agents && agents.length > 0 && (
            <div className="d-flex flex-row ml-4">
              <button
                className="approve-btn mr-3"
                onClick={() => 
                  setShowModal(true)}
              >
                Approve
              </button>
              <button className="hold-payout-btn download-btn" onClick={handleDownload}>
                {csvLoader ?
                  <SmallLoader />
                  : <>
                  <img src={ibadown} alt="" width={"12px"} height={"12px"} /> Download CSV
                  </>}
                
              </button>
            </div>
          )}

          {/* Approve Confirmation Modal */}
          <Modal
            show={showModal}
            size="lg"
            centered
            className="rm-model filter-update-telecaller iba-approve-modal"
          >
            <Modal.Body>
              <div className="close-button-modal">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="btn-close filter-closeBtn"
                  aria-label="Close"
                >
                  <span className="icon-close"></span>
                </button>
              </div>

              <div className="profile-modal-content iba-modal-content">
                <div className="iba-worning">
                  <img src={warningiba} alt="" height={"60px"} width={"60px"} />
                  <span>Are you sure?</span>
                  <span style={{ fontSize: "14px", color: "#c0c0c0", fontWeight: "400"}}>
                    Approve payout for all Agents?
                  </span>
                </div>
                <div className="profile-footer-iba">
                  <Button
                    className="cancel-btn-iba"
                    onClick={() => setShowModal(false)}
                  >
                    No
                  </Button>
                  <Button
                    type="submit"
                    className="save-btn-iba"
                    onClick={() => {
                      handleApprove("APPROVED".toLowerCase())
                      
                    }}
                  >
                    Yes
                  </Button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </main>
      ) : (
        <IbaHoldPayout
          setShowHoldpayout={setShowHoldpayout}
          refreshActiveAgents={() => fetchAgents()}
          handleApprove={handleApprove}
        />
      )}
    </div>
  );
};

export default IbaPayoutApproval;
